import { useSelector } from "react-redux";
import { CardVariant } from "../../models/CardVariant"
import { classNames } from "../../style/common";
import { RootState } from "../../store";
import { UserSettings } from "../../models/UserSettings";

export type CardVariantImageVariantOverlayProps = {
    variant: CardVariant,
    className?: string | undefined
}

export function FoilOverlay(props: CardVariantImageVariantOverlayProps) {
    const userSettings = useSelector<RootState, UserSettings>(x => x.user.userSettings);
    const isFoil = props.variant.finish === "foil";

    if (!isFoil || !userSettings.foilIndicator) {
        return undefined;
    }

    const size = "-.3rem";

    return (
        <div className={classNames("rounded-2xl", props.className)} style={{
            position: "absolute",
            content:"",
            top: size,
            bottom: size,
            left: size,
            right: size,
            backgroundImage: "linear-gradient(43deg, #4158D0 0%, #C850C0 46%, #FFCC70 100%)",
            filter: "blur(.3rem)",
        }} />
    );
}